import { useFlags } from 'flagsmith/react';
import { get } from 'lodash';

export const useFeatureFlag = (feature: string): boolean => {
    const flags = useFlags([feature]);
    return Boolean(get(flags, `${feature}.enabled`, false));
};

export const useFeatureFlagsValues = (features: string[]): Record<string, boolean> => {
    const flags = useFlags(features);

    return features.reduce(
        (acc, feature) => {
            acc[feature] = Boolean(get(flags, `${feature}.enabled`, false));
            return acc;
        },
        {} as Record<string, boolean>
    );
};
